import { jsxs as e, jsx as i } from "react/jsx-runtime";
import { memo as v } from "react";
import { u as t } from "../styled-components.browser.esm-BFmoFexH.js";
import D from "../selector/metrics/display/MetricOptionsResume.js";
import "dayjs";
import "../period-BbmcGyLd.js";
import { D as y } from "../MetricGrowthResume-ClJnPTa-.js";
import { useHasGrowthApplied as T, useHasFilterApplied as w, useHasPeriodApplied as C } from "../metricDisplay/MetricDisplay.hooks.js";
import { l as b } from "../lodash-DeBCDn4U.js";
import { TooltipContainer as E, TooltipAlias as F, IconContainer as l, TooltipContentElement as a, MdView as H, concatInformationLinkToText as L } from "@biron-data/react-components";
import { useLanguageResolver as M } from "@biron-data/react-contexts";
import { o as d, a as S } from "../index-a388f2ac-Cf1pu7LW.js";
const Q = v(({ timeInterval: r, metric: o, getMoreInformationLink: m }) => {
  var n, p, s;
  const h = M(), f = m(o.metricCode), x = y(r), g = T(o), u = w(o), A = C(o);
  return /* @__PURE__ */ e(E, { children: [
    /* @__PURE__ */ e(F, { translate: "no", children: [
      /* @__PURE__ */ i(l, { size: 22, children: /* @__PURE__ */ i(d, {}) }),
      /* @__PURE__ */ i("div", { children: o.metricAlias })
    ] }),
    /* @__PURE__ */ e(a, { children: [
      /* @__PURE__ */ e(c, { children: [
        /* @__PURE__ */ i(S, {}),
        o.viewAlias
      ] }),
      /* @__PURE__ */ e(c, { children: [
        /* @__PURE__ */ i(l, { size: 22, children: /* @__PURE__ */ i(d, {}) }),
        ((n = o.metricDef) == null ? void 0 : n.alias) ?? ""
      ] }),
      !b.isEmpty((p = o.metricDef) == null ? void 0 : p.description) && /* @__PURE__ */ i(k, { children: /* @__PURE__ */ i(H, { description: L((s = o.metricDef) == null ? void 0 : s.description, h, f), padding: 0 }) })
    ] }),
    (g || u || A) && /* @__PURE__ */ i(j, {}),
    /* @__PURE__ */ i(a, { children: /* @__PURE__ */ i(
      D,
      {
        value: o,
        iconSpan: 2,
        isNameDisplayed: !1,
        timeInterval: r,
        dayDifference: x,
        additionnalStyle: "gap: 10px;",
        hideDisplayOptions: !0
      }
    ) })
  ] });
}), j = t.div`
  height: 0;
  border-top: 1px solid var(--light-grey);
  margin-bottom: 15px;
    width: calc(100% - 18px);
`, k = t.div`
  margin-bottom: 10px;
`, c = t.div`
  display: flex;
  align-items: center;
  gap: 15px;
    align-content: start;
    line-height: 22px;
`;
export {
  Q as TooltipContentMetric
};
//# sourceMappingURL=TooltipContent.Metric.js.map
